import React, { useState } from "react";
import { Layout, Menu, Drawer, Button } from "antd";
import {
  FileTextOutlined,
  LogoutOutlined,
  UserOutlined,
  ShopOutlined,
  MenuOutlined,
  CloseOutlined,
  SafetyCertificateOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/Icons/logo.png";

import "./styles.css";
import { useUserContext } from "../../Contexts/user";

const { Header, Sider, Content } = Layout;

const getSelectedKey = () => {
  const last = window.location.pathname.split("/").slice(-1)[0];
  switch (last) {
    case "contracts": return ["1"];
    case "merchants": return ["2"];
    case "vendors":   return ["3"];
    case "users":     return ["4"];
    case "mfa":       return ["5"];
    default:          return ["1"];
  }
};

const AdminLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const { logout, userData } = useUserContext();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const menuItems = [
    {
      key: "1",
      icon: <FileTextOutlined />,
      label: "Contracts",
      onClick: () => navigate("/admin/contracts"),
    },
  ];

  if (userData?.role === "admin") {
    menuItems.push({
      key: "2",
      icon: <UserOutlined />,
      label: "Merchants",
      onClick: () => navigate("/admin/merchants"),
    });
  }

  if (userData?.role === "admin" || userData?.role === "merchant") {
    menuItems.push({
      key: "3",
      icon: <ShopOutlined />,
      label: "Vendors",
      onClick: () => navigate("/admin/vendors"),
    });
  }

  if (
    userData?.role === "admin" ||
    userData?.role === "merchant" ||
    userData?.assistant === true
  ) {
    menuItems.push({
      key: "4",
      icon: <TeamOutlined />,
      label: "Users",
      onClick: () => navigate("/admin/users"),
    });
  }

  // MFA is available to every admin-role user
  menuItems.push({
    key: "5",
    icon: <SafetyCertificateOutlined />,
    label: "MFA Security",
    onClick: () => navigate("/admin/mfa"),
  });

  return (
    <Layout className="admin-layout">
      {/* Desktop Sidebar */}
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={250}
        className="admin-sider"
        breakpoint="lg"
        collapsedWidth={0}
        onBreakpoint={(broken) => setCollapsed(broken)}
      >
        <div className="logo-container">
          <img src={logo} alt="Logo" />
        </div>

        <Menu
          theme="light"
          mode="inline"
          defaultSelectedKeys={getSelectedKey()}
          items={menuItems}
          className="admin-menu"
        />

        <div className="logout-container">
          <Button
            type="primary"
            danger
            icon={<LogoutOutlined />}
            block
            onClick={handleLogout}
            className="logout-button"
          >
            {!collapsed && "Logout"}
          </Button>
        </div>
      </Sider>

      <Layout className="layout-content">
        {/* Header */}
        <Header className="admin-header">
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            className="trigger-button"
          />
          <div className="header-right">
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setDrawerOpen(true)}
              className="mobile-menu-button"
            />
          </div>
          <div className="header-brand">
            <div className="header-show-info">
              <h1>Arett Sales</h1>
            </div>
          </div>
        </Header>

        {/* Mobile Drawer Menu */}
        <Drawer
          title="Menu"
          placement="left"
          onClose={() => setDrawerOpen(false)}
          open={drawerOpen}
          bodyStyle={{ padding: 0, display: "flex", flexDirection: "column" }}
          closeIcon={<CloseOutlined />}
        >
          <div className="mobile-logo-container">
            <img src={logo} alt="Logo" />
          </div>
          <Menu
            theme="light"
            mode="inline"
            items={menuItems}
            onClick={() => setDrawerOpen(false)}
            style={{ flex: 1 }}
          />
          <div className="drawer-logout-container">
            <Button
              type="primary"
              danger
              icon={<LogoutOutlined />}
              block
              onClick={() => {
                handleLogout();
                setDrawerOpen(false);
              }}
            >
              Logout
            </Button>
          </div>
        </Drawer>

        {/* Main Content */}
        <Content className="admin-content">{children}</Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
